<template>
	<div>
		<el-dialog append-to-body :title="title" :visible.sync="dialogVisible" width="1200px" @open="dialogOpen"
			:before-close="handleClose" destroy-on-close>
			<div class="content">
				<div class="attachment_img_left" v-loading="groupListLoading">
					<div class="list">
						<div class="item" @click="chooseCategory(item)" :class="item.id==currentCategory.id?'active':''"
							v-for="(item,index) in categoryList" :key="index">
							{{item.name}}
							<div class="del-cate" @click.stop="delCate(item)">
								<i class="el-icon-circle-close"></i>
							</div>
						</div>
					</div>

					<div class="add-cate-btn">
						<el-popover placement="top" width="160" v-model="visible">
							<el-input v-model="new_type_name" placeholder="請輸入分类名稱" size="mini"></el-input>
							<div style="text-align: right; margin: 0;margin-top: 10px;">
								<el-button size="mini" type="text" @click="visible = false">取消</el-button>
								<el-button type="primary" size="mini" @click="addNewAttType">確定</el-button>
							</div>
							<el-button slot="reference" style="margin-left:25px;margin-top: 13px" size="small">
								<i class="el-icon-circle-plus-outline"></i> 新建分类
							</el-button>
						</el-popover>
					</div>
				</div>

				<div class="attachment_img_right" v-loading="imageLoading">
					<div class="top flex">
						<div>
							<el-upload class="upload-demo" :action="uploadPath" :on-remove="handleRemove"
								:on-success="uploadSuccess" :data="dataOption" multiple :limit="20"
								:on-exceed="handleExceed" :show-file-list="false"
								accept="image/jpeg,image/jpg,image/png">
								<el-button size="small" type="primary">点击上传</el-button>
							</el-upload>
						</div>
						<div class="mr-l20">
							<el-button size="small" type="danger" :disabled="disabledDel" @click="del">删除选中</el-button>
						</div>
						<div class="mr-l20">
							<el-dropdown :disabled="disabledDel" @command="moveClick">
								<el-button type="primary" size="small">
									移动到<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item :command="index" v-for="(item,index) in groupList"
										:key="index">{{item.name}}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
						<!-- <div class="mr-l20 flex">
							<el-input placeholder="請輸入链接地址进行采集" v-model="gatherUrl" clearable size="small"></el-input>
							<el-button :loading="gatherLoading" size="mini" class="mr-l15" type="primary" @click="handleGather">确认采集</el-button>
						</div> -->
					</div>
					<div class="imageList">
						<el-row :gutter="20">
							<el-col :span="4" v-for="(item,index) in imageList" :key="index">
								<div class="item" @click="chooseImg(index)">
									<el-image style="width:120px;height:120px;border-radius: 10px;"
										:src="item.att_dir + '?imageView2/1/w/100/h/100'">
									</el-image>
									<div class="mask" v-if="item.choosed==true">
										<i class='el-icon-check'></i>
									</div>
								</div>
							</el-col>
						</el-row>
					</div>
					<div class="pager">
						<el-pagination background @current-change="handleCurrentChange" :current-page="page"
							:page-size="pageSize" layout="total, prev, pager, next, jumper" :total="dataObj.total">
						</el-pagination>
					</div>
				</div>

			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="handleClose">取 消</el-button>
				<el-button type="primary" size="small" @click="submit">確 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			dialogVisible: {
				type: Boolean,
				default: false
			},
			title: {
				type: String,
				default: "上传圖片"
			},
			limit: {
				type: Number,
				default: 1
			}
		},
		data() {
			return {
				uploadPath: this.$api.BaseUrl + this.$api.file.cosUpload,
				visible: false,
				disabledDel: true,
				new_type_name: "",
				groupListLoading: true,
				imageLoading: true,
				gatherLoading:false,
				fileList: [],
				categoryList: [],
				groupList: [],
				currentCategory: {},
				imageList: [],
				dataObj: {},
				dataOption: {
					pid: 0
				},
				gatherUrl:"",
				page: 1,
				pageSize: 18,
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			submit() {
				let count = 0;
				this.imageList.forEach((item) => {
					if (item.choosed) {
						count++;
					}
				})

				if (count > this.limit) {
					this.$message.error("只能选取" + this.limit + "张圖片");
					return false;
				}
				if(this.fileList==null || this.fileList==''){
					this.$message.error("請選擇圖片");
					return false;
				}
				if(this.limit==1){
					this.$emit("submit",this.fileList[this.fileList.length - 1]);
					return false;
				}else{
					this.$emit("submit", this.fileList);
				}
			},
			handleGather(){
				if(this.gatherUrl==""){
					this.$message.error("請輸入网络地址");
					return false;
				}
				this.gatherLoading =  true;
				this.$request({
					url:this.$api.file.gather,
					data:{
						cate_id:this.currentCategory.id,
						url:this.gatherUrl
					}
				}).then((res)=>{
					this.gatherLoading = false;
					if(res.data.code==1){
						this.$message.success(res.data.msg);
						this.page = 1;
						this.getImageList();
					}else{
						this.$message.error(res.data.msg);
					}
				})
			},
			handleCurrentChange(e) {
				this.page = e;
				this.getImageList();
			},
			handleExceed() {

			},
			handleRemove() {

			},
			//删除分类
			delCate(data) {
				this.$confirm('此操作將永久刪除，是否繼續?', '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if (data.id == 0) {
						this.$message.error("此分类无法删除");
						return false;
					}

					this.$request({
						url: this.$api.file.deleteCategory,
						data: {
							id: data.id
						}
					}).then((res) => {
						if (res.data.code == 1) {
							this.$message.success(res.data.msg);
							this.getCategoryList();
							this.currentCategory = {
								id: 0,
								name: "全部"
							};
							this.page = 1;
							this.getImageList();
						} else {
							this.$message.error(res.data.msg);
						}
					})
				})
			},
			moveClick(e) {
				let group_id = this.groupList[e].id;
				let list = [];
				this.imageList.forEach((item) => {
					if (item.choosed) {
						list.push(item.att_id);
					}
				})
				if (list == '' || list == null) {
					this.$message.error("請選擇圖片");
					return false;
				}

				let ids = list.join(",");


				this.$request({
					url: this.$api.file.move,
					data: {
						pid: group_id,
						images: ids
					}
				}).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.page = 1;
						this.getImageList();
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
			del() {
				this.$confirm('此操作將永久刪除，是否繼續?', '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let _id = [];
					this.imageList.forEach((item) => {
						if (item.choosed) {
							_id.push(item.att_id);
						}
					})
					_id = _id.join(",");

					this.$request({
						url: this.$api.file.deleteImage,
						method: "post",
						data: {
							ids: _id
						}
					}).then((res) => {
						if (res.data.code == 1) {
							this.$message.success(res.data.msg);
							this.getImageList();
						} else {
							this.$message.error(res.data.msg);
						}
					}).catch(() => {
						this.$message.error("请求失败");
					})
				}).catch(() => {

				});
			},
			chooseImg(index) {

				this.imageList[index].choosed = !this.imageList[index].choosed;
				if(this.imageList[index].choosed){
					if(this.fileList.indexOf(this.imageList[index].att_dir)<0){
						this.fileList.push(this.imageList[index].att_dir);
					}
				}else{
					let _index = this.fileList.indexOf(this.imageList[index].att_dir);
					this.fileList.splice(_index,1);
				}

				let count = 0;
				this.imageList.forEach((item) => {
					if (item.choosed) {
						count++;
					}
				})

				if (count > 0) {
					this.disabledDel = false;
				} else {
					this.disabledDel = true;
				}
			},
			chooseCategory(item) {
				this.currentCategory = item;
				this.dataOption.pid = item.id;
				this.page = 1;
				this.imageList = [];
				this.getImageList();
			},
			uploadSuccess() {
				this.getImageList();
			},
			//获取圖片列表
			getImageList() {
				this.imageLoading = true;
				this.$request({
					url: this.$api.file.imageList,
					data: {
						pid: this.currentCategory.id,
						page: this.page,
						pageSize: this.pageSize
					}
				}).then((res) => {
					this.imageList = [];
					let list = res.data.data.data;
					if (list != '' && list != undefined && list != null) {
						list.forEach((item) => {
							item.choosed = false;
							this.imageList.push(item);
						})
					}
					this.disabledDel = true;
					this.imageLoading = false;
					this.dataObj = res.data.data;
				})
			},
			//添加新分类
			addNewAttType() {
				if (this.new_type_name == "") {
					this.$message.error("請輸入名稱");
					return false;
				}
				this.visible = false;
				this.$request({
					url: this.$api.file.addCategory,
					method: "POST",
					data: {
						name: this.new_type_name,
						pid: 0
					}
				}).then((res) => {
					this.new_type_name = "";
					if (res.data.code == 1) {
						this.getCategoryList();
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
			//获取分类列表
			getCategoryList() {
				this.$request({
					url: this.$api.file.categoryList,
				}).then((res) => {
					this.categoryList = [...[{
						id: 0,
						name: "全部"
					}], ...res.data.data];
					this.currentCategory = this.categoryList[0];
					this.groupList = res.data.data;
					this.groupListLoading = false;
					this.getImageList();
				})
			},

			//对话框打开
			dialogOpen() {
				this.getCategoryList();
			},
			handleClose() {
				this.$emit("close");
			}
		}
	}
</script>

<style scoped>
	.content {
		width: 100%;
		height: 550px;
		position: relative;
		display: flex;
		justify-content: space-between;
	}

	.attachment_img_left {
		width: 170px;
		height: 100%;
		border-right: 1px solid #ededed;
		position: relative;
	}

	.attachment_img_left .item {
		width: 150px;
		height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		position: relative;
	}

	.item .del-cate {
		position: absolute;
		display: none;
		top: -5px;
		right: -5px;
		font-size: 16px;
	}

	.item:hover .del-cate {
		display: block;
	}

	.attachment_img_left .active {
		background-color: #c3e1fe;
		color: #409eff;
		border-radius: 8px;
	}

	.add-cate-btn {
		position: absolute;
		bottom: 0;
	}

	.attachment_img_right {
		width: 1000px;
		padding-left: 15px;
		position: relative;
	}

	.pager {
		position: absolute;
		bottom: 0;
		right: 0;
	}

	.imageList .item {
		margin-top: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
	}

	.imageList .item .mask {
		width: 120px;
		height: 120px;
		position: absolute;
		background: rgba(0, 0, 0, 0.3);
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 10px;
	}

	.imageList .item .mask i {
		font-size: 30px;
		color: white;
	}
</style>



// WEBPACK FOOTER //
// src/components/uploadPicture/uploadPicture.vue